import { createSlice } from '@reduxjs/toolkit';
import { getList } from '../server/lists';

const initialActiveListState = {
    activeList: {
        _id: '',
        name: '',
        type: '',
        color: '',
        icon: '',
        creator: '',
        defaultViewId: '',
        data: [],
        views: [],
        columns: [],
        sharingMailObject: {},
        fileManagerObject: {},
    },
    activeView: {
        _id: '',
        name: '',
        type: '',
        columns: []
    },
    extraListsData: {},
    extraListsDataOptions: {},
    // subListsMapping: {},
    // subListsObjects: {},
    // subListsViewMapping: {},
}

const activeListSlice = createSlice({
    name: 'activeList',
    initialState: initialActiveListState,
    reducers: {
        resetActiveList(state) {
            state.activeList = {
                _id: '',
                name: '',
                type: '',
                color: '',
                icon: '',
                creator: '',
                defaultViewId: '',
                data: [],
                views: [],
                columns: [],
                sharingMailObject: {},
                fileManagerObject: {},
            }
        },
        updateActiveList(state, actions) {
            state.activeList = actions.payload;
        },
        updateActiveListData(state, actions) {
            state.activeList.data = actions.payload;
        },
        updateActiveListDataRowById(state, actions) {
            const rowIndex = state.activeList.data.findIndex(r => r._id === actions.payload._id);
            if (rowIndex >= 0) {
                state.activeList.data[rowIndex][actions.payload.property] = actions.payload.value;
            }
        },
        updateActiveListProperty(state, actions) {
            state.activeList[actions.payload.property] = actions.payload.value;
        },
        addRowToActiveList(state, actions) {
            const row = actions.payload.row;
            state.activeList.data.push(row);
        },
        updateRowToActiveList(state, actions) {
            const rowId = actions.payload.rowId;
            const row = actions.payload.row;
            if (rowId && row) {
                const rowIndex = state.activeList.data.findIndex((r) => r._id === rowId);
                if (rowIndex >= 0) {
                    state.activeList.data[rowIndex] = row;
                }
            }
        },

        updateExtraListsData(state, actions) {
            state.extraListsData[actions.payload.lid] = actions.payload.value;
        },
        updateExtraListsDataOptions(state, actions) {
            state.extraListsDataOptions[actions.payload.lid] = actions.payload.options;
        },

        resetExtraListsData(state, actions) {
            state.extraListsData = {};
        },
        resetExtraListsDataOptions(state, actions) {
            state.extraListsDataOptions = {};
        },

        resetActiveView(state) {
            state.activeView = {
                _id: '',
                name: '',
                type: '',
                columns: []
            }
        },
        updateActiveView(state, actions) {
            state.activeView = actions.payload;
        },
        updateActiveViewColumns(state, actions) {
            state.activeView.columns = actions.payload;

            const viewIndex = state.activeList.views.findIndex((v) => v._id.toString() === state.activeView._id);
            if (viewIndex >= 0) {
                state.activeList.views[viewIndex].columns = actions.payload;
            }
        },
        updateActiveListViewProperty(state, actions) {
            const viewId = actions.payload.viewId;
            const property = actions.payload.property;
            const value = actions.payload.value;

            const viewIndex = state.activeList.views.findIndex((v) => v._id.toString() === viewId);
            if (viewIndex >= 0) {
                const updatedView = JSON.parse(JSON.stringify(state.activeList.views[viewIndex]));
                updatedView[property] = value;
                state.activeList.views[viewIndex] = updatedView;
            }
        },
        updateActiveViewProperty(state, actions) {
            const property = actions.payload.property;
            const value = actions.payload.value;

            const updatedView = JSON.parse(JSON.stringify(state.activeView));
            updatedView[property] = value;
            state.activeView = updatedView;
        },
    }
});

export const activeListActions = activeListSlice.actions;
export default activeListSlice;

export const fetchActiveListById = (listId) => {
    return async (dispatch) => {
        dispatch(activeListActions.resetActiveList());
        dispatch(activeListActions.resetActiveView());
        // dispatch(activeListActions.resetSubListsMapping());
        // dispatch(activeListActions.resetSubListsObjects());
        // dispatch(activeListActions.resetSubListsViewMapping());

        try {
            const res = await getList(listId);
            const listData = res.data;
            if (listData) {
                dispatch(activeListActions.updateActiveList(listData));
            }
            // dispatch(activeListActions.updateSubListsMapping(res.subListsMapping || {}));
            // dispatch(activeListActions.updateSubListsObjects(res.subListsObjects || {}));
            // dispatch(activeListActions.updateSubListsViewMapping(res.subListsObjects || {}));
        } catch (err) {
            console.log('catch error: ', err);
        }
    }
}

export const fetchActiveListDataById = (listId) => {
    return async (dispatch) => {
        try {
            const res = await getList(listId);
            const listData = res.data;
            if (listData) {
                dispatch(activeListActions.updateActiveListData(listData.data || []));
            }
        } catch (err) {
            console.log('catch error: ', err);
        }
    }
}